/* eslint-disable @typescript-eslint/no-unused-vars */
import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import pdfApi from '../../api/pdfApi';
import { ComprasMockProvider } from './ComprasMockProvider';
import { MocksHelper } from './MocksHelper';

const comprasProvider = new ComprasMockProvider();
const ComprasMockService = {
  retrieveCompra: (input: object) => {
    const data = comprasProvider.getComprasResponse();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  retrieveCompraByDates: (input: any) => {
    const from = input.fromDate;
    const to = input.toDate;
    const data = comprasProvider.getComprasResponseByDates(from, to);
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
  detalleCompraDownload: (params: number) => {
    return trackPromise(
      pdfApi.get(
        `/rest/compras/tickets/${i18next.language}/download/detalle/compra/id?idCompra=99990672071620634072`,
      ),
    );
  },
  ticketDownload: (params: number) =>
    trackPromise(
      pdfApi.get(
        `/rest/compras/tickets/${i18next.language}/download/ticket/id?idTicket=99990672071620634072`,
      ),
    ),
  ticketOption: (data: object) => {
    return Promise.resolve(
      MocksHelper.getAxiosResponse(comprasProvider.isActivo),
    );
  },
  ticketPapelState: () => {
    const data = {
      error: false,
    };
    comprasProvider.setActivo();
    return Promise.resolve(MocksHelper.getAxiosResponse(data));
  },
};
export default ComprasMockService;
